import React, { useEffect } from "react";
import { Modal, Form, Input, Button, notification } from "antd";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateVendor } from "../services/vendorsAPI";

const UpdateVendorModal = ({ visible, onClose, vendor }) => {
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const mutation = useMutation({
    mutationFn: ({ vendorId, vendorData }) =>
      updateVendor(vendorId, vendorData),
    onSuccess: () => {
      queryClient.invalidateQueries("vendors");
      onClose();
      form.resetFields();
      notification.success({ message: "Vendor updated successfully" });
    },
    onError: (error) => {
      notification.error({
        message: "Failed to update vendor",
        description: error.message,
      });
    },
  });

  useEffect(() => {
    if (visible) {
      form.setFieldsValue({
        name: vendor.name,
        dba: vendor.dba,
      });
    }
  }, [visible, vendor, form]);

  const handleUpdateVendor = (values) => {
    const vendorData = {
      ...values,
    };
    mutation.mutate({ vendorId: vendor.id, vendorData });
  };

  return (
    <Modal
      title="Update Vendor"
      visible={visible}
      onCancel={onClose}
      footer={null}
    >
      <Form form={form} onFinish={handleUpdateVendor} layout="vertical">
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input the vendor name!" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item label="DBA" name="dba">
          <Input />
        </Form.Item>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={mutation.isPending}
            style={{ width: "100%" }}
          >
            Update Vendor
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UpdateVendorModal;
